import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import featureConstants from '@constants/featureConstants';
import { getAppShopsToShowSelector } from '@redux/reducers/app/appSelector';
import {
  getCollectionPointDetailsCallActiveSelector,
  getActiveModalMapMarkerSelector,
  getActiveViewTypeSelector,
  getClickAndCollectActiveMapMarkerSelector,
  getClickAndCollectCountdownVisibleSelector,
  getClickAndCollectCutOffTimeForAllStoresSelector,
  getClickAndCollectEarliestCollectionDateTimeSelector,
  getClickAndCollectSelectingCollectionPointIdSelector,
  getClickAndCollectStoreToPromoteSelector,
  getCollectionPointDatesApiCallActiveSelector,
  getCollectionPointSearchActiveSelector,
  getCollectionPointSearchCompleteSelector,
  getCollectionPointSearchResultsSelector,
  getCollectionPointSearchTermSelector,
  getCollectionPointsOwnersSelector,
  getFindCollectionPointErrorSelector,
  getIsFreeCollectionSelector,
  getModalShowSelectShopButtonSelector,
  getSavedCollectionPointsApiCallLoadingSelector,
  getSelectedCollectionPointSelector,
  getStoreDetailsModalOpenSelector,
  getTotalCollectionPointsSelector,
  getHideMapInStoreDetailsModalSelector,
} from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import { isFeatureActive } from '@redux/reducers/config/configReducer';
import {
  getShowSavedCollectionPointsModalSelector,
  getShouldUseFasterCollectionSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { getUserSavedCollectionPointsSelector } from '@redux/reducers/user/userSelector';

const getFreeClickCollectFeatureSelector = (state: RootState) =>
  isFeatureActive(state, featureConstants.FREE_CLICK_COLLECT);

const clickAndCollectState = createSelector(
  [
    getCollectionPointSearchResultsSelector,
    getCollectionPointSearchTermSelector,
    getCollectionPointSearchActiveSelector,
    getCollectionPointSearchCompleteSelector,
    getFindCollectionPointErrorSelector,
    getStoreDetailsModalOpenSelector,
    getModalShowSelectShopButtonSelector,
    getSelectedCollectionPointSelector,
    getTotalCollectionPointsSelector,
    getShowSavedCollectionPointsModalSelector,
    getUserSavedCollectionPointsSelector,
    getActiveModalMapMarkerSelector,
    getCollectionPointDetailsCallActiveSelector,
    getCollectionPointDatesApiCallActiveSelector,
    getSavedCollectionPointsApiCallLoadingSelector,
    getActiveViewTypeSelector,
    getCollectionPointsOwnersSelector,
    getIsFreeCollectionSelector,
    getFreeClickCollectFeatureSelector,
    getClickAndCollectActiveMapMarkerSelector,
    getClickAndCollectCountdownVisibleSelector,
    getClickAndCollectCutOffTimeForAllStoresSelector,
    getClickAndCollectEarliestCollectionDateTimeSelector,
    getAppShopsToShowSelector,
    getClickAndCollectSelectingCollectionPointIdSelector,
    getClickAndCollectStoreToPromoteSelector,
    getHideMapInStoreDetailsModalSelector,
    getShouldUseFasterCollectionSelector,
  ],
  (
    collectionPointSearchResults,
    collectionPointSearchTerm,
    collectionPointSearchActive,
    collectionPointSearchComplete,
    findCollectionPointError,
    storeDetailsModalOpen,
    modalShowSelectShopButton,
    selectedCollectionPoint,
    totalCollectionPoints,
    showSavedCollectionPointsModal,
    savedCollectionPoints,
    activeModalMapMarker,
    getCollectionPointDetailsCallActive,
    getCollectionPointDatesApiCallActive,
    getSavedCollectionPointsApiCallLoading,
    activeViewType,
    collectionPointsOwners,
    isFreeCollection,
    freeClickCollect,
    activeMapMarker,
    countdownVisible,
    cutOffTimeForAllStores,
    earliestCollectionDateTime,
    shopsToShow,
    selectingCollectionPointId,
    storeToPromote,
    hideMapInStoreDetailsModal,
    shouldUseFasterCollection,
  ) => ({
    collectionPointSearchResults,
    collectionPointSearchTerm,
    collectionPointSearchActive,
    collectionPointSearchComplete,
    findCollectionPointError,
    storeDetailsModalOpen,
    modalShowSelectShopButton,
    selectedCollectionPoint,
    totalCollectionPoints,
    showSavedCollectionPointsModal,
    savedCollectionPoints,
    activeModalMapMarker,
    getCollectionPointDetailsCallActive,
    getCollectionPointDatesApiCallActive,
    getSavedCollectionPointsApiCallLoading,
    activeViewType,
    collectionPointsOwners,
    isFreeCollection: freeClickCollect || isFreeCollection,
    activeMapMarker,
    countdownVisible,
    cutOffTimeForAllStores,
    earliestCollectionDateTime,
    shopsToShow,
    selectingCollectionPointId,
    storeToPromote,
    hideMapInStoreDetailsModal,
    shouldUseFasterCollection,
    renderLoadingWrapper: !selectedCollectionPoint && getSavedCollectionPointsApiCallLoading,
    renderCollectionSearch: !selectedCollectionPoint && !getSavedCollectionPointsApiCallLoading,
    renderCollectionSearchResults: collectionPointSearchComplete && totalCollectionPoints > 0,
  }),
);

export default clickAndCollectState;
